export enum IsLowInventory {
  No,
  Yes,
  YesManufacturerOut,
}
